export default __webpack_public_path__ + "static/media/slider02.7d37f881.webp";